/* eslint-disable no-empty */
import { SupportWidget, AdminWidget, CalendarWidget } from '../widgets';

// 'require' can not accept variables,
// so loop can not be used here
export default () => {
  const widgets = {};

  // admin
  try {
    widgets.admin = AdminWidget;
  } catch (e) {}

  // calendar
  widgets.calendar = CalendarWidget;

  // support
  widgets.support = SupportWidget;

  return widgets;
};
